import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {connect} from 'react-redux';

import Modal        from 'app/components/common/modal';
import {
  DeviceTypes,
}                   from 'app/constants';
import Duck         from 'app/dotsnake/ducks/game';
import SnakeManager from 'app/dotsnake/game/manager';
import AuthDuck     from 'app/ducks/auth';
import history      from 'app/history';
import paths        from 'app/paths';

const {Ax, Slx} = Duck;

class ModalLogout extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClickLogout = this.onClickLogout.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentWillUnmount() {
    this.props.clear();
  }

  onClickLogout(event) {
    event?.preventDefault && event.preventDefault();
    this.props.logout().then(() => {
      this.onClose();
    });
  }

  onClose() {
    this.props.onClose();
  }

  render() {
    const {pending} = this.props;

    return (
      <Modal bgClose={false} className="snk-modal-login snk-modal" onClose={this.onClose}>
        <h1 className="snk-modal-title">Sign Out</h1>
        <p className="snk-modal-p">Are you sure?</p>
        <p className="snk-modal-p">Scores will not be saved when you’re signed out.</p>
        <div className="snk-modal-actions">
          <button className="snk-btn mint" onClick={this.onClickLogout} disabled={pending}>{pending ? 'Signing Out...' : 'Sign Out'}</button>
        </div>
      </Modal>
    );
  }

}

ModalLogout.propTypes = {
  onClose: PropTypes.func.isRequired,
};

const stateToProps = (state) => ({
  pending: AuthDuck.Slx.logoutPending(state),
  // failed: AuthDuck.Slx.logoutFailed(state),
  // success: AuthDuck.Slx.logoutSuccess(state),
});

const dispatchToProps = (dispatch) => ({
  logout: () => dispatch(AuthDuck.Ax.logout()),
  clear: () => dispatch(AuthDuck.Ax.clearLogout()),
});

export default connect(stateToProps, dispatchToProps)(ModalLogout);
